export const stripRegionDesignator = (code: string) => {
  const dashPos = code.indexOf('-');
  return dashPos > 0 ? code.substring(0, dashPos) : code;
};
